import { styled } from '@mui/material/styles';
import { Box, Card, Chip, Fab, Tabs, Button } from '@mui/material';
import { motion } from 'framer-motion';

/** Palet POS datar (tanpa gradien / aksen “neon”) */
export const POS_PRIMARY = '#0052CC';
export const POS_PRIMARY_HOVER = '#0747A6';
export const POS_BG = '#f6f7fb';
export const POS_BORDER = '#e4e8ef';
export const POS_PAY_GREEN = '#16a34a';
export const POS_PAY_GREEN_HOVER = '#15803d';

export const ModernProductCard = styled(Card)(({ disabled }) => ({
  cursor: disabled ? 'not-allowed' : 'pointer',
  borderRadius: '14px',
  overflow: 'hidden',
  backgroundColor: 'white',
  boxShadow: '0 2px 10px rgba(9, 30, 66, 0.06)',
  border: `1px solid ${POS_BORDER}`,
  transition: 'transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease',
  opacity: disabled ? 0.55 : 1,
  '&:hover': {
    transform: disabled ? 'none' : 'translateY(-1px)',
    boxShadow: disabled ? undefined : '0 8px 20px rgba(9, 30, 66, 0.10)',
    borderColor: disabled ? undefined : '#d1d8e3',
  },
}));

export const CategoryChip = styled(Chip)(({ selected }) => ({
  borderRadius: '999px',
  padding: '0 6px',
  height: '36px',
  fontWeight: 700,
  fontSize: '13px',
  backgroundColor: selected ? POS_PRIMARY : 'white',
  color: selected ? 'white' : '#42526e',
  border: selected ? 'none' : `1px solid ${POS_BORDER}`,
  flexShrink: 0,
  '&:hover': {
    backgroundColor: selected ? POS_PRIMARY_HOVER : '#f4f5f7',
  },
}));

export const StockBadge = styled(Box)(() => ({
  position: 'absolute',
  top: 10,
  right: 10,
  backgroundColor: 'rgba(255, 255, 255, 0.95)',
  borderRadius: '999px',
  padding: '4px 10px',
  fontSize: '12px',
  fontWeight: 700,
  color: '#42526e',
  backdropFilter: 'blur(10px)',
  boxShadow: '0 2px 10px rgba(9,30,66,0.12)',
}));

export const FloatingCartButton = styled(Fab)(() => ({
  position: 'fixed',
  bottom: 80,
  right: 20,
  backgroundColor: POS_PRIMARY,
  color: 'white',
  boxShadow: '0 6px 18px rgba(9, 30, 66, 0.22)',
  '&:hover': {
    backgroundColor: POS_PRIMARY_HOVER,
  },
}));

// Styled components from appDemo.jsx
export const StyledCard = styled(motion(Card))(({ theme }) => ({
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: theme.shadows[8],
  },
}));

export const StatusChip = styled(Chip)(({ theme }) => ({
  backgroundColor: '#4CAF50',
  color: 'white',
  '& .MuiChip-icon': {
    color: 'white',
  },
}));

export const MenuCategoryTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  marginBottom: theme.spacing(2),
  '& .MuiTab-root': {
    textTransform: 'none',
    fontSize: '1rem',
  },
}));

export const PaymentButton = styled(Button)(({ theme, active }) => ({
  borderColor: active ? theme.palette.primary.main : theme.palette.divider,
  backgroundColor: active ? theme.palette.primary.light : 'transparent',
  color: active ? 'white' : theme.palette.text.primary,
  '&:hover': {
    backgroundColor: active ? theme.palette.primary.main : theme.palette.action.hover,
  },
}));

